/**
 * Hauler Hire Card Component
 * Displays empty hauler slot with hire button
 */

import { useGameStore } from '@/state';
import { haulerManager } from '@/systems';
import { formatCurrency } from '@/data/balance/balanceConfig';

interface HaulerHireCardProps {
  slotNumber: number;
}

export function HaulerHireCard({ slotNumber }: HaulerHireCardProps) {
  const currency = useGameStore((state) => state.playerState.currency);
  const cost = haulerManager.getHaulerCost(slotNumber);
  const canAfford = currency >= cost;

  const handleHire = () => {
    if (haulerManager.hireHauler(slotNumber)) {
      console.log(`Hired hauler ${slotNumber}!`);
    }
  };

  return (
    <div className="p-6 rounded-xl border-2 border-dashed border-gray-600 bg-gray-800/30 flex flex-col items-center justify-center min-h-[400px] hover:border-orange-500/50 transition-all">
      {/* Empty slot icon */}
      <div className="text-6xl mb-4 opacity-30">🚚</div>

      {/* Slot info */}
      <h3 className="text-lg font-bold text-gray-400 mb-2">
        Hauler Slot {slotNumber}
      </h3>
      <p className="text-sm text-gray-500 mb-4 text-center max-w-xs">
        Haulers automatically take fish from your inventory and sell them at the shop, keeping your automation running smoothly.
      </p>

      {/* Hire button */}
      <button
        onClick={handleHire}
        disabled={!canAfford}
        className={`px-6 py-3 rounded-lg font-bold transition-all ${
          canAfford
            ? 'bg-orange-600 hover:bg-orange-700 text-white hover:scale-105'
            : 'bg-gray-700 text-gray-500 cursor-not-allowed'
        }`}
      >
        {canAfford ? (
          <>
            Hire for {formatCurrency(cost)} 💰
          </>
        ) : (
          <>
            Need {formatCurrency(cost)} 💰
          </>
        )}
      </button>

      {/* Helper text */}
      {!canAfford && (
        <p className="text-xs text-gray-600 mt-3">
          Keep fishing and selling to earn more gold!
        </p>
      )}
    </div>
  );
}
